// extracted by mini-css-extract-plugin
module.exports = {"container":"Automations_container__srfs9","column":"Automations_column__2ue8T"};